const DB_ATTRIBUTES = {
    "category" : [
        {"value" : "Men", "uid" : 1, "image": "/assets/images/91125A81_1_2.jpg"}, 
        {"value" : "Women", "uid" : 2, "image": "/assets/images/6515541.png"},
        {"value" : "Kids", "uid" : 3, "image": "/assets/images/3214970.png"} 
    ],
    "size" : [
        {"value" : 36, "uid" : 11},
        {"value" : 37, "uid" : 12},
        {"value" : 38, "uid" : 13},
        {"value" : 39, "uid" : 14},
        {"value" : 40, "uid" : 15},
        {"value" : 41, "uid" : 16},
        {"value" : 42, "uid" : 17},
    ],
    "brands" : [
        {value : "Venturini", uid : 31},
        {value : "Maverick", uid : 32},
        {value : "Apex", uid : 33},
        {value : "Bata Red Label", uid : 34},
    ],
    "year" : [
        {"value" : 2015, "uid" : 21},
        {"value" : 2016, "uid" : 22},
        {"value" : 2017, "uid" : 23},
        {"value" : 2018, "uid" : 24},
        {"value" : 2019, "uid" : 25},
        {"value" : 2020, "uid" : 26},
        {"value" : 2021, "uid" : 27},
    ],
}

export default DB_ATTRIBUTES;